export default __webpack_public_path__ + "media/zurb/img/case-study-cartpros/cartpros-hero-215be63db3a2d98e4c7da07c6dd3cc2b.jpg";